export enum ModalStatusInvoiceBatchCreatedNotificationEnums {
	INACTIVE = 'inactive',
	ACTIVE = 'active',
	FAILED = 'failed'
}
